export enum ViRouteType {
    HYPE = 'HYPE',
    NEW = 'NEW',
    EDIT = 'EDIT',
    REPORTS = 'REPORTS',
    QUERIES_AND_ANSWERS = 'QUERIES_AND_ANSWERS'
}
